
import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="bg-directpress-dark text-white py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="max-w-2xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white">
              Journalism Unfiltered: Direct from Writers to Readers
            </h1>
            <p className="text-lg md:text-xl text-gray-100 opacity-90 mb-8">
              A decentralized platform that empowers independent journalists to publish and monetize their content without traditional publishers.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-directpress-orange hover:bg-directpress-orange/90 text-white">
                <Link to="/home">
                  Explore Content
                </Link>
              </Button>
              <Button 
                asChild 
                size="lg" 
                variant="tertiary" 
                className="text-directpress-dark font-medium border-white/40 hover:bg-white"
              >
                <Link to="/auth?role=journalist">
                  Join as Writer
                </Link>
              </Button>
            </div>
          </div>
          <div className="hidden lg:block">
            <div className="bg-directpress-dark/50 rounded-xl p-8 border border-white/20">
              <div className="h-64 bg-white/10 rounded-lg flex items-center justify-center text-gray-200">
                Platform Visual Representation
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
